import {Component} from '@angular/core';
import {QuickViewBaseComponent} from '@bbndev/ngx-bbn-zvendo';

@Component({
	selector: 'app-quick-view',
	templateUrl: './quick-view.component.html',
	styleUrls: ['./quick-view.component.scss']
})
export class QuickViewComponent extends QuickViewBaseComponent {
}
